export const AppPaths = {
  main: '/',
  methodology: '/methodology/',
  aboutUs: '/about-us/',
  contacts: '/contact/',
  impressum: '/impressum/',
  disclaimer: '/disclaimer/',
  privacyPolicy: '/privacy-policy/',
};
